import { Component, Input } from '@angular/core';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmePipesModule } from '../../../vme-pipes.module';

@Component({
  selector: 'vertical-dots-container',
  templateUrl: './vertical-dots-container.component.html',
  styleUrls: ['./vertical-list-dots.scss'],
  standalone: true,
  imports: [VmeCommonModule, VmePipesModule],
})
export class VerticalDotsContainerComponent {
  @Input() position: 'start' | 'middle' | 'end' | 'none';

  @Input() iconClass: string = 'fa fa-circle-o';

  @Input() iconSize: 'small' | 'large' = 'large';

  @Input() noIcon: boolean = false;

  @Input() customIcon: string;

  @Input() showTime: number = null;

  @Input() narrowDots: boolean = false;

  @Input() lineClass: string = '';
}
